'use strict';

var React = require('react');

var SvgCreditCardReaderChipIcon = function SvgCreditCardReaderChipIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.121 3.5h3.758c.395 0 .736 0 1.017.023.297.024.592.078.875.222.424.216.768.56.984.984.144.283.198.578.222.875.023.28.023.622.023 1.017v3.816a2.751 2.751 0 0 1 1.75 2.563v2a1.75 1.75 0 0 1-1.75 1.75h-10a1.75 1.75 0 0 1-1.75-1.75v-2a2.75 2.75 0 0 1 1.75-2.563v-3.816c0-.395 0-.736.023-1.017a2.29 2.29 0 0 1 .222-.875 2.25 2.25 0 0 1 .984-.984 2.29 2.29 0 0 1 .875-.222c.28-.023.622-.023 1.017-.023Zm.029 1.5h1.85v5h-3.5v-3.35c0-.432 0-.712.018-.924.017-.204.045-.28.064-.316a.75.75 0 0 1 .328-.328c.037-.02.112-.047.316-.064.212-.017.492-.018.924-.018Zm3.85 0v5h1.5v-3.35c0-.432 0-.712-.018-.924-.017-.204-.045-.28-.064-.316a.75.75 0 0 0-.327-.328c-.038-.02-.113-.047-.317-.064a10.44 10.44 0 0 0-.774-.018Zm-7.25 8c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v2a.25.25 0 0 1-.25.25h-10a.25.25 0 0 1-.25-.25v-2Z"
  }));
};
SvgCreditCardReaderChipIcon.displayName = "CreditCardReaderChipIcon";

exports.SvgCreditCardReaderChipIcon = SvgCreditCardReaderChipIcon;
